<div *ngIf="config" class="flex flex-col gap-6 mb-8 vs-app-page-header">
  <ng-content select="[slot='breadcrumbs']"></ng-content>

  <div class="flex justify-between flex-col sm:flex-row gap-4">
    <div class="flex flex-col overflow-hidden">
      <h1
        class="flex gap-2 text-gray-900 font-semibold"
        [class.items-center]="!config.wrapTitle"
        [class.items-start]="config.wrapTitle"
        [class.text-xl]="config.isSubPage"
        [class.text-3xl]="!config.isSubPage"
      >
        <vs-icon *ngIf="config.icon" [name]="config.icon" size="30" class="text-gray-700"></vs-icon>
        <div
          [vsTooltip]="config.title"
          tooltipOpenDelay="350"
          tooltipPosition="top"
          tooltipStyle="light"
          [class.truncate]="!config.wrapTitle"
          [class.whitespace-normal]="config.wrapTitle"
          [class.break-words]="config.wrapTitle"
        >
          {{ config.title }}
        </div>
        <ng-content select="[slot='title-end']"></ng-content>
      </h1>

      <p class="text-sm text-gray-600 mt-1 empty:hidden">
        <ng-content select="[slot='before-description']"></ng-content>{{ config.description }}
      </p>
    </div>

    <div class="peer/header-end [&:not(:has(*))]:hidden">
      <ng-content select="[slot='header-end']"></ng-content>
    </div>

    <vs-divider
      *ngIf="!config.showDivider"
      class="sm:hidden -mb-4 peer-[&:not(:has(*))]/header-end:hidden"
    ></vs-divider>
  </div>

  <vs-divider *ngIf="config.showDivider"></vs-divider>

  <div class="sticky top-0 empty:hidden"><ng-content select="[slot='sticky']"></ng-content></div>
</div>

<ng-content></ng-content>
